<template>
  <div class="preloader" v-if="isLoading">
    <span class="preloader__spinner far fa-spinner fa-spin" />
  </div>
  <div v-else-if="isAccessGranted" class="vis-container">
    <vis-toolbar :items="toolbar" class="vis-grid-toolbar" />
    <div class="vis-settings vis-has-toolbar">
      <div class="vis-gutter-3 d-flex flex-wrap">
        <template v-for="setting in settings">
          <div v-bind:key="setting.ID" class="vis-card">
            <div class="card-body">
              <i
                :class="setting.Icon.Value"
                :style="`color:${setting.Icon.Color};`"
              ></i>
              <span style="padding: 10px">{{ setting.Title }}</span>
            </div>
            <div class="btn-toolbar d-flex border-top">
              <b-button
                block
                variant="outline-primary"
                @click="setting.visible = true"
                class="border-0"
              >{{ $t("tune") }}</b-button>
            </div>
            <vis-detail-view-dialog
              :crudService="getCrudService(setting.Mnemonic)"
              :visible="setting.visible"
              @hide="setting.visible = false"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
  <div v-else>{{ $t("accessDenied")}}</div>
</template>
<script>
import api from "@/api/visary-api";
import visDetailViewDialog from "../views/base/common/vis-detail-view-dialog";
import SettingsCrudService from "@/shared/services/settings-crud-service";

 const HIDDEN_SETTINGS = {
   underuonstructionsettings: true, //Настройка для уведомл. о недоступности
   documentflowmailsetting: true, //Настройка документооборота
   documentflowusersetting: true, //Настройка документооборота для почты
   productrequestsettings: true, //Настройка для запросов
   applicationsetting: true, //Настройка приложения
   dashboardsettings: true, //Настройка дашборда
   opendatasettings: true, //Настройка открытых данных
   calendarsettings: true, //Настройки календаря
   employeesetting: true, //Настройка сотрудников
   securitysetting: true, //Настройки безопасности
   supportsettings: true, //Настройки тех. поддержки
   workflowsetting: true, //Настройка бизнес-процессов
   imagesetting: true, //Настройка изображений
   mapsetting: true, //Настройки карты
   jobsetting: true, //
   underconstructionsettings: true, // уведомления о недоступности
 }

export default {
  name: "vis-settings",
  components: { visDetailViewDialog },
  data() {
    return {
      settings: [],
      isAccessGranted: false,
      isLoading: false,
      toolbar: [
        {
          id: "buttons",
          type: "button-group",
          buttons: [
            {
              icon: "fal fa-question",
              type: "vis-mnemonic-help-toolbar-button",
              mnemonic: "SettingsHelpFile",
              title: this.$t("toolbar.button.Help"),
            }
          ]
        }
      ]
    };
  },
  async created() {
    this.checkAccess()
    await this.loadSettings()
  },

  methods: {
    getCrudService(mnemonic) {
      return new SettingsCrudService(mnemonic);
    },
    async checkAccess() {
      this.isLoading = true

      this.isAccessGranted = await api.user.checkPathAccess({ path: this.$route.path })

      this.isLoading = false
    },
    async loadSettings() {
      const data = await api.settings.getAll();
      this.settings = (data || [])
        .filter(item => ! HIDDEN_SETTINGS.hasOwnProperty(
            item?.Mnemonic.toLowerCase()
        ) )
        .map(item => {
          return {
            ...item,
            visible: false
          }
      })
    }
  },
};
</script>

<style lang="scss">
.vis-container {
  height: inherit;
  padding-bottom: inherit;
}
.vis-settings {
  box-sizing: border-box;
  width: 100%;
  margin: 5px 0;
  overflow-y: auto;
}
@media screen and (max-width: 700px) {
  .vis-card {
    width: 45%;
  }
}
@media screen and (max-width: 500px) {
  .vis-card {
    width: 80%;
  }
}
</style>
